import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tw-p-10 modal-manage-role" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-[15px]" }
const _hoisted_3 = { class: "tw-text-[25px] tw-text-[#211F58] tw-font-[600] tw-leading-none" }
const _hoisted_4 = { class: "tw-flex tw-flex-col tw-gap-[20px]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#F7553C]" }, "*", -1)
const _hoisted_6 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_7 = {
  key: 0,
  class: "tw-px-[0px] tw-py-[15px] tw-w-full tw-flex tw-items-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-h-[1px] tw-bg-[#EFF0F1]" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "tw-text-[#211F58] tw-text-[18px] tw-not-italic tw-font-[600] tw-leading-[130%]"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#F7553C]" }, "*", -1)
const _hoisted_12 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#F7553C]" }, "*", -1)
const _hoisted_14 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "tw-px-[0px] tw-py-[15px] tw-w-full tw-flex tw-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-h-[1px] tw-bg-[#EFF0F1]" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#F7553C]" }, "*", -1)
const _hoisted_17 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#F7553C]" }, "*", -1)
const _hoisted_19 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_20 = { class: "button-container tw-flex tw-flex-col tw-items-end tw-mt-[20px]" }
const _hoisted_21 = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_22 = ["fill"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.0811 14.992H14.8491V18.304H13.1531V14.992H9.92106V13.456H13.1531V10.144H14.8491V13.456H18.0811V14.992Z",
  fill: "white"
}, null, -1)

import store from "../../../store";
import utilities, {
  getComponentUiText,
  getProgressAnimation,
} from "../../../utils/utilities";
import { Ref, computed, reactive, ref, watch } from "vue";

import Modal from "../../common/modal.vue";
import ModalHeader from "../../common/modalHeader.vue";
import CustomBDropDown from "../../common/customBDropDown.vue";
import CustomBDropDownItem from "../../common/customBDropDownItem.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import CustomMultiSelectSearch from "@/components/common/customMultiSelectSearch.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  getOrgRoletypes,
  postOrgRole,
  getOrgMembersAddable,
  getOrgAccessGranted,
} from "@/services/org";
import get from "lodash/get";
import { IOrgDetails } from "@/interfaces/orgInterfaces";
import { IOrgRoleInput } from "@/interfaces/org/role";
import BaseInput from "@/components/common/form/baseInput.vue";
import BaseForm from "@/components/common/form/baseForm.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { LottieAnimation } from "lottie-web-vue";

const DEFAULT_MAX_WIDTH_MODAL = 65;
const CUSTOM_CLASS_INPUT_INVALID = "input-invalid-style-1";
const cssFieldTitle =
  "tw-border tw-text-[#231F20] tw-text-[13px] tw-leading-none tw-px-[20px] tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#EFF0F180] tw-max-w-[520px]";


export default /*#__PURE__*/_defineComponent({
  __name: 'addRoleModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
},
  emits: ["update:show", "add:organisation"],
  setup(__props, { emit }) {

const props = __props;

const activeItem = ref(0);
const remainingAccessableOrgs = ref([]);
const noOfAnotherOrgs = ref(0);
const anotherOrgUsers = ref([]);

// Form modal and validation.
let formModel = reactive({
  roleTitle: "",
  privilegeLevel: [] as IDropDownData[],
  organisation: [] as IDropDownData[],
  users: [] as IDropDownData[],
  anotherOrganisation: [] as IDropDownData[],
  anotherOrgUsers: [],
});

const rules = {
  roleTitle: {
    required,
  },
  privilegeLevel: {
    required,
  },
  organisation: {
    required,
  },
  users: {
    required: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-team-roles-add-role-modal-form-error-required-users-1",
        ),
      required,
    ),
  },
  anotherOrganisation: {
    required: noOfAnotherOrgs.value > 0 ? true : false,
  },
  anotherOrgUsers: {
    required:
      noOfAnotherOrgs.value > 0
        ? helpers.withMessage(
            () =>
              getComponentUiText(
                "app-settings-team-roles-add-role-modal-form-error-required-users-1",
              ),
            required,
          )
        : false,
  },
};
const currentOrg: Ref<IOrgDetails> = computed(
  () => store.getters["Org/getOrgDetails"],
);
const userSelectsCurrentOrg: Ref<any> = computed(
  () => store.getters["Org/getAddableOrgs"],
);
const userSelects: Ref<IDropDownData[]> = ref([]);
const organisationOptions: Ref<IDropDownData[]> = ref([]);
const privilegeLevelOptions: Ref<IDropDownData[]> = ref([]);

const formModalOrigin = Object.assign({}, formModel);
const addAnotherOrgUserDisable = ref(organisationOptions.value.length <= 1);
const showLoadingSubmitButton: Ref<boolean> = ref(false);

let vueValidate;
let showRef = ref(props.show);
let needCheckValidSelectUsers = ref(false);
let customClassInputInvalidRoleTitle = ref(cssFieldTitle);
watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) {
      initial();
      vueValidate = useVuelidate(rules, formModel);
      if (organisationOptions.value.length) onSelectOrgDefault();
    }
  },
);

watch(
  () => formModel.organisation,
  () => {
    formModel.anotherOrganisation = [];
    anotherOrgUsers.value = [];
  },
);
watch(
  [() => formModel.organisation, () => formModel.anotherOrganisation],
  () => {
    const ids = [
      ...Object.values(formModel.anotherOrganisation).map(
        (org: any) => org?.id,
      ),
      formModel.organisation[0]?.id,
    ];
    remainingAccessableOrgs.value = organisationOptions.value.filter(
      (org) => !ids.includes(org?.id),
    ) as any;
  },
  { deep: true, immediate: true },
);

watch(
  () => organisationOptions.value,
  (value) => {
    addAnotherOrgUserDisable.value = value?.length <= 1;
    noOfAnotherOrgs.value = 0;
    formModel.anotherOrganisation = [];
    formModel.anotherOrgUsers = [];
  },
  { immediate: true },
);

const onSelectOrgDefault = () => {
  const indexOrg = organisationOptions.value.findIndex((org) => {
    return org.id === currentOrg.value.id;
  });
  const indexSelectedOrg = indexOrg > -1 ? indexOrg : 0;
  formModel.organisation = [organisationOptions.value[indexSelectedOrg]];
  userSelects.value = userSelectsCurrentOrg.value;
  userSelects.value.forEach((e, index) => {
    e._index = index;
  });
};

const initial = async () => {
  if (organisationOptions.value.length) await onSelectOrgDefault();

  getPrivilegeLevelOptions();
  await getDataOption();

  showRef.value = props.show;
  vueValidate = useVuelidate(rules, formModel);
};

const getDataOption = async () => {
  await getOrganizationOptions();
};

const getPrivilegeLevelOptions = async () => {
  try {
    const responseData = await getOrgRoletypes();
    const privilegeLevelOptionsResponse = get(responseData, "data.data", []);
    privilegeLevelOptions.value = privilegeLevelOptionsResponse.map((item) => {
      return {
        id: item.roleTypeId,
        name: item.roleTypeName,
      };
    });
  } catch (error: any) {
    privilegeLevelOptions.value = [];
    if (error && error.data) {
      showErrorAPI(error, Org.getOrgRoleTypes);
    }
  }
};

const getOrganizationOptions = async () => {
  try {
    const responseData = await getOrgAccessGranted();
    const organizationOptionsResponse = get(
      responseData,
      "data.data.grantedOrgs",
      [],
    );
    organizationOptionsResponse.push({
      org2Id: currentOrg.value.id,
      org2NameShort: currentOrg.value.nameShort,
    });
    organisationOptions.value = organizationOptionsResponse.map((item) => {
      return {
        id: item.org2Id, // TO-DO: Change to orgId
        name: item.org2NameShort,
      };
    });
    onSelectOrgDefault();
  } catch (error: any) {
    organisationOptions.value = [];
    if (error && error.data) {
      showErrorAPI(error, Org.getAccessGrantedToOtherOrgs);
    }
  }
};

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const handleInputRoleTitle = () => {
  vueValidate.value.roleTitle.$touch();
  vueValidate.value.roleTitle.$model = formModel.roleTitle;

  if (vueValidate.value.roleTitle.$errors.length) {
    customClassInputInvalidRoleTitle.value = `${customClassInputInvalidRoleTitle.value} ${CUSTOM_CLASS_INPUT_INVALID}`;
  } else customClassInputInvalidRoleTitle.value = cssFieldTitle;
};

const handleInputUser = (value) => {
  if (needCheckValidSelectUsers.value === false) return;

  formModel.users = value;
  vueValidate.value.users.$touch();
  vueValidate.value.users.$model = formModel.users;
};

const handleSelectOrganisation = (item: IDropDownData) => {
  formModel.organisation = [item];
  vueValidate.value.organisation.$touch();
  vueValidate.value.organisation.$model = formModel.organisation;
  getUserOfOrg(item.id);
};

const handleSelectAnotherOrganisation = (item: any, index: number) => {
  formModel.anotherOrganisation[index] = item;
  vueValidate.value.anotherOrganisation.$touch();
  vueValidate.value.anotherOrganisation.$model = formModel.anotherOrganisation;
  getUserOfOrg(item.id, index, true);
};

const getUserOfOrg = async (
  orgId: any,
  index: any = -1,
  isAnotherOrgUsers = false,
) => {
  try {
    const responseData = await getOrgMembersAddable(orgId);
    if (responseData.data?.data?.length) {
      if (isAnotherOrgUsers) {
        if (index === -1) return;
        const temp: any = [...anotherOrgUsers.value];
        temp[index] = responseData.data.data.map((org: any) => {
          return {
            ...org,
            id: org.userId,
            name: `${org.firstName} ${org.lastName}`,
          };
        });
        anotherOrgUsers.value = temp;
      } else {
        userSelects.value = responseData.data.data.map((org: any) => {
          return {
            ...org,
            id: org.userId,
            name: `${org.firstName} ${org.lastName}`,
          };
        });
      }
    }
  } catch (error: any) {
    organisationOptions.value = [];
    if (error && error.data) {
      showErrorAPI(error, Org.getAddableOrgMembers);
    }
  }
};

const handleSelectPrivilegeLevel = (item: IDropDownData) => {
  formModel.privilegeLevel = [item];
  vueValidate.value.privilegeLevel.$touch();
  vueValidate.value.privilegeLevel.$model = formModel.privilegeLevel;
};
const handleDrop = () => {
  activeItem.value = 0;
};
const moveSelectionDown = (step) => {
  if (privilegeLevelOptions.value.length - 1 == activeItem.value) {
    activeItem.value = privilegeLevelOptions.value.length - 1;
  } else if (activeItem.value < privilegeLevelOptions.value.length) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop += 61;
    }
  }
};
const moveSelectionUp = (step) => {
  if (activeItem.value >= 1) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop -= 61;
    }
  }
};
const handlEnter = () => {
  const handleData = privilegeLevelOptions.value[activeItem.value];
  handleSelectPrivilegeLevel(handleData);
};
const onSubmit = async () => {
  try {
    showLoadingSubmitButton.value = true;
    needCheckValidSelectUsers.value = true;

    const result = await vueValidate.value.$validate();
    if (result) {
      const payload: IOrgRoleInput = {
        roleName: formModel.roleTitle,
        roleDescription: "",
        roleTypeId: formModel.privilegeLevel[0].id as string,
        roleMembers: formModel.users.map((item) => item.id) as any,
      };
      const res = await postOrgRole(payload);
      await store.dispatch("Org/fetchOrgRoles");
      const roleTitle = formModel.roleTitle;
      EventEmitter.emit(EmitterEvents.ROLE_CREATED, {
        roleTitle,
        member: res.data?.data || {},
      });
      handleCloseModal();
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.postOrgRole);
    }
  } finally {
    showLoadingSubmitButton.value = false;
  }
};

const clearData = () => {
  formModel = reactive(Object.assign({}, formModalOrigin));
  userSelects.value.forEach((item) => (item.selected = false));
  customClassInputInvalidRoleTitle.value = cssFieldTitle;
  vueValidate.value.$reset();
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  needCheckValidSelectUsers.value = false;
  emit("update:show", showRef.value);
};

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] !tw-max-h-[913px] role-details-modal",
    "max-width": DEFAULT_MAX_WIDTH_MODAL,
    visible: _unref(showRef),
    value: _unref(formModel),
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        title: getUiText('app-settings-team-roles-add-role-modal-title-1'),
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createVNode(BaseForm, {
        show: _unref(showRef),
        "enter-event": true,
        class: "tw-overflow-auto",
        "onOn:submit": onSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(getUiText("app-settings-team-roles-add-role-modal-sub-title-1")), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(BaseInput, {
                modelValue: _unref(formModel).roleTitle,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).roleTitle) = $event)),
                validation: _unref(vueValidate).roleTitle,
                "validate-on-blur": true,
                "data-cy-id": "add-role-modal-role-title",
                placeholder: 
              _unref(getComponentUiText)(
                'app-settings-team-roles-add-role-modal-form-prompt-role-title-1',
              )
            ,
                label: 
              _unref(getComponentUiText)(
                'app-settings-team-roles-add-role-modal-form-label-role-title-1',
              )
            ,
                "onUpdate:value": handleInputRoleTitle
              }, null, 8, ["modelValue", "validation", "placeholder", "label"]),
              _createVNode(_component_b_row, { class: "sm-display-column-container tw-flex tw-justify-between tw-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    sm: "5",
                    class: "field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getUiText(
                  "app-settings-team-roles-add-role-modal-form-label-privilege-level-1",
                )) + " ", 1),
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    sm: "7",
                    class: "field-content-container tw-flex"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(CustomBDropDown, {
                          id: 'dropdownIcon',
                          type: 'single',
                          data: _unref(formModel).privilegeLevel,
                          validation: _unref(vueValidate)?.privilegeLevel,
                          "data-cy-id": "add-role-modal-privilege-level",
                          "class-name": 'gray-dropdown-container tw-h-[58px]',
                          placeholder: 
                    getUiText(
                      'app-settings-team-roles-add-role-modal-form-prompt-privilege-level-1',
                    )
                  ,
                          "onUpdate:moveSelectionDown": moveSelectionDown,
                          "onUpdate:showDrop": handleDrop,
                          "onUpdate:enterValue": handlEnter,
                          "onUpdate:moveSelectionUp": moveSelectionUp
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privilegeLevelOptions.value, (level, index) => {
                              return (_openBlock(), _createBlock(CustomBDropDownItem, {
                                key: index,
                                "data-cy-id": `add-role-modal-privilege-level-${index}`,
                                data: level,
                                "class-name": `normal-dropdown-container ${
                      activeItem.value === index ? 'activeItem' : ''
                    }`,
                                onClick: ($event: any) => (handleSelectPrivilegeLevel(level))
                              }, null, 8, ["data-cy-id", "data", "class-name", "onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["data", "validation", "placeholder"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (noOfAnotherOrgs.value > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                : _createCommentVNode("", true),
              (noOfAnotherOrgs.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(getComponentUiText)(
                "app-component-add-role-modal-add-users-role-1",
              )), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_b_row, { class: "sm-display-column-container tw-flex tw-justify-between tw-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    sm: "5",
                    class: "field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getUiText(
                  "app-component-custom-b-dropdown-label-organisation-1",
                )) + " ", 1),
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    sm: "7",
                    class: "field-content-container tw-flex"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(CustomBDropDown, {
                          id: 'dropdownIcon',
                          type: 'single',
                          data: _unref(formModel).organisation,
                          validation: _unref(vueValidate)?.organisation,
                          "class-name": 'gray-dropdown-container tw-h-[58px]',
                          placeholder: 
                    getUiText(
                      'app-component-custom-b-dropdown-prompt-organisation-1',
                    )
                  ,
                          "onUpdate:moveSelectionDown": moveSelectionDown,
                          "onUpdate:showDrop": handleDrop,
                          "onUpdate:enterValue": handlEnter,
                          "onUpdate:moveSelectionUp": moveSelectionUp
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organisationOptions.value, (company, index) => {
                              return (_openBlock(), _createBlock(CustomBDropDownItem, {
                                key: index,
                                data: company,
                                "class-name": `normal-dropdown-container ${
                      activeItem.value === index ? 'activeItem' : ''
                    }`,
                                onClick: ($event: any) => (handleSelectOrganisation(company))
                              }, null, 8, ["data", "class-name", "onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["data", "validation", "placeholder"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_b_row, { class: "sm-display-column-container tw-flex tw-justify-between tw-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_col, {
                    sm: "5",
                    class: "field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getUiText("app-component-custom-b-dropdown-label-select-user-1")) + " ", 1),
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_col, {
                    sm: "7",
                    class: "field-content-container tw-flex"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(CustomMultiSelectSearch, {
                          modelValue: _unref(formModel).users,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => ((_unref(formModel).users) = $event)),
                            _cache[2] || (_cache[2] = ($event: any) => (handleInputUser($event)))
                          ],
                          options: userSelects.value,
                          "track-by": "name",
                          "data-cy-id": "add-role-modal-select-user",
                          label: "name",
                          placeholder: `${getUiText(
                    'app-settings-team-roles-add-role-modal-form-prompt-select-users-1',
                  )}`,
                          "show-check-box": true,
                          validation: _unref(vueValidate)?.users,
                          "onClose:modal": _cache[3] || (_cache[3] = ($event: any) => (handleInputUser($event)))
                        }, null, 8, ["modelValue", "options", "placeholder", "validation"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(noOfAnotherOrgs.value).keys()], (i, indx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: indx,
                  class: "tw-flex tw-flex-col tw-gap-[20px]"
                }, [
                  _hoisted_15,
                  _createVNode(_component_b_row, { class: "sm-display-column-container tw-flex tw-justify-between tw-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, {
                        sm: "5",
                        class: "field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getUiText(
                    "app-component-custom-b-dropdown-label-another-organisation-1",
                  )) + " ", 1),
                          _hoisted_16
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_col, {
                        sm: "7",
                        class: "field-content-container tw-flex"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(CustomBDropDown, {
                              id: 'dropdownIcon',
                              type: 'single',
                              data: [_unref(formModel).anotherOrganisation[indx]],
                              validation: _unref(vueValidate)?.anotherOrganisation,
                              "class-name": 'gray-dropdown-container tw-h-[58px]',
                              placeholder: 
                      getUiText(
                        'app-component-custom-b-dropdown-prompt-organisation-1',
                      )
                    ,
                              "onUpdate:moveSelectionDown": moveSelectionDown,
                              "onUpdate:showDrop": handleDrop,
                              "onUpdate:enterValue": handlEnter,
                              "onUpdate:moveSelectionUp": moveSelectionUp
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                        _unref(formModel).anotherOrganisation[indx],
                        ...remainingAccessableOrgs.value,
                      ].filter((item) => item), (company, index) => {
                                  return (_openBlock(), _createBlock(CustomBDropDownItem, {
                                    key: index,
                                    data: company,
                                    "class-name": `normal-dropdown-container ${
                        activeItem.value === index ? 'activeItem' : ''
                      }`,
                                    onClick: ($event: any) => (handleSelectAnotherOrganisation(company, indx))
                                  }, null, 8, ["data", "class-name", "onClick"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["data", "validation", "placeholder"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_b_row, { class: "sm-display-column-container tw-flex tw-justify-between tw-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, {
                        sm: "5",
                        class: "field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getUiText(
                    "app-component-custom-b-dropdown-label-select-user-1",
                  )) + " ", 1),
                          _hoisted_18
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_col, {
                        sm: "7",
                        class: "field-content-container tw-flex"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(CustomMultiSelectSearch, {
                              modelValue: _unref(formModel).anotherOrgUsers[indx],
                              "onUpdate:modelValue": [
                                ($event: any) => ((_unref(formModel).anotherOrgUsers[indx]) = $event),
                                _cache[4] || (_cache[4] = ($event: any) => (handleInputUser($event)))
                              ],
                              options: anotherOrgUsers.value[indx],
                              "track-by": "name",
                              label: "name",
                              placeholder: `${getUiText(
                      'app-settings-team-roles-add-role-modal-form-prompt-select-users-1',
                    )}`,
                              "show-check-box": true,
                              validation: _unref(vueValidate)?.users,
                              "onClose:modal": _cache[5] || (_cache[5] = ($event: any) => (handleInputUser($event)))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "validation"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: _normalizeClass(`tw-flex tw-mb-[40px] tw-gap-[10px] tw-cursor-pointer ${
              addAnotherOrgUserDisable.value ? 'tw-pointer-events-none' : ''
            }`),
                onClick: _cache[6] || (_cache[6] = 
              () => {
                noOfAnotherOrgs.value = noOfAnotherOrgs.value + 1;
                if (organisationOptions.value.length - noOfAnotherOrgs.value <= 1) {
                  addAnotherOrgUserDisable.value = true;
                }
              }
            )
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(`tw-text-[13px] ${
                addAnotherOrgUserDisable.value
                  ? 'tw-text-[#B7B7B7]'
                  : 'tw-text-[#231F20]'
              } tw-font-medium tw-leading-[28px]`)
                }, _toDisplayString(getUiText(
                  "app-settings-team-roles-add-role-modal-form-button-add-user-description-1",
                )), 3),
                (_openBlock(), _createElementBlock("svg", _hoisted_21, [
                  _createElementVNode("rect", {
                    width: "28",
                    height: "28",
                    rx: "14",
                    fill: addAnotherOrgUserDisable.value ? '#DBDBDB' : '#387DFF'
                  }, null, 8, _hoisted_22),
                  _hoisted_23
                ]))
              ], 2),
              _createVNode(_component_b_button, {
                "data-cy": "add-role-modal-submit-button",
                type: "submit",
                variant: "primary",
                class: "button-verify tw-bg-[#387DFF] tw-h-[39px] tw-py-0 tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
              }, {
                default: _withCtx(() => [
                  (showLoadingSubmitButton.value)
                    ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
                        key: 0,
                        class: _normalizeClass('tw-h-[41px] tw-w-full'),
                        "animation-data": _unref(getProgressAnimation)(),
                        "auto-play": true,
                        loop: true
                      }, null, 8, ["animation-data"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(getUiText(
                  "app-settings-team-roles-add-role-modal-form-button-create-role-1",
                )), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }, 8, ["visible", "value"]))
}
}

})